import React from "react";
import { EmblaOptionsType } from "embla-carousel";
import useEmblaCarousel from "embla-carousel-react";
import { CardProduct } from "../CardProduct";
import { IProducts } from "../../interfaces/shopify";
import {
  NextFeaturedButton,
  PrevFeaturedButton,
  usePrevFeaturedNextButtons,
} from "./components/EmblaFeaturedButton";
import "../../css/EmblaFeature.css";
import { Box, Fade } from "@mui/material";
import { LoadSlider } from "../LoadSlider";

type PropType = {
  category?: string;
  slides: IProducts[];
  options?: EmblaOptionsType;
  isLoading: boolean;
};

export const EmblaFeatured: React.FC<PropType> = ({
  category,
  slides,
  options,
  isLoading,
}) => {
  const [emblaRef, emblaApi] = useEmblaCarousel(options);

  const {
    prevBtnDisabled,
    nextBtnDisabled,
    onPrevButtonClick,
    onNextButtonClick,
  } = usePrevFeaturedNextButtons(emblaApi);

  return (
    <section className="embla__featured">
      {isLoading ? (
        <LoadSlider />
      ) : (
        <Fade in timeout={1500}>
          <Box>
            <Box className="embla__viewport__featured" ref={emblaRef}>
              <Box className="embla__container__featured">
                {slides
                  .filter(
                    (p) =>
                      p?.images?.edges?.length &&
                      p.images.edges[0]?.node &&
                      p?.variants?.edges?.length &&
                      p.variants.edges[0]?.node
                  )
                  .map((p) => (
                    <Box className="embla__slide__featured" key={p.id}>
                      <CardProduct
                        to={`/products/${p.handle}`}
                        image={p.images.edges[0].node.url}
                        alt={p.images.edges[0].node.altText ?? ""}
                        title={p.title}
                        category={category}
                        currency={p.variants.edges[0].node.price.currencyCode}
                        price={p.variants.edges[0].node.price.amount}
                        comparePrice={
                          p.variants.edges[0].node.compareAtPrice?.amount
                        }
                      />
                    </Box>
                  ))}
              </Box>
            </Box>
            <Box className="embla__controls__featured">
              <PrevFeaturedButton
                onClick={onPrevButtonClick}
                disabled={prevBtnDisabled}
              />
              <NextFeaturedButton
                onClick={onNextButtonClick}
                disabled={nextBtnDisabled}
              />
            </Box>
          </Box>
        </Fade>
      )}
    </section>
  );
};
